import { socialMediaRegex } from 'shared'
import { socialMediaRegexErrorMessage } from 'utils/validations'
import * as Yup from 'yup'

export const editSocialValidationSchema = () =>
  Yup.object().shape({
    instagramHandle: Yup.string()
      .required()
      .matches(socialMediaRegex, socialMediaRegexErrorMessage)
      .label('Instagram username'),
    tiktokHandle: Yup.string()
      .matches(socialMediaRegex, socialMediaRegexErrorMessage)
      .label('Tiktok username'),
  })
